export const months = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
]

export const monthsNice = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const newDate = (date, toString) =>
  toString
    ? new Date(date || new Date().toString()).toString()
    : new Date(date || new Date().toString())

export const dateLastDayOfMonth = (month, year) =>
  new Date(year, months.indexOf(month) + 1, 0)

export const getNextDay = date => new Date(date.setDate(date.getDate() + 1))

export const currentMonth = months[newDate().getMonth()]
export const currentYear = new Date().getFullYear()

/**
 * DEBUG INFORMATION
 */
const debug = () => {
  window.dbdates = {}
  window.dbdates.currentMonth = currentMonth
  window.dbdates.currentYear = currentYear
  window.dbdates.dldom = dateLastDayOfMonth
  window.dbdates.nd = newDate
  window.dbdates.gnd = getNextDay
}
// debug()
